import { VOtpInput } from 'vuetify/lib/components/VOtpInput';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.col ? `col-md-${_vm.col}` : ''},[_c('div',{staticClass:"input_wrapper",attrs:{"dir":"ltr"}},[_c(VOtpInput,{attrs:{"type":"text","length":_vm.otpLength,"value":_vm.value},on:{"input":function($event){return _vm.updateValue($event)}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }